import getDefaultState from './get-default-state';

export default {
  setActionBarCountry(state, country) {
    state.actionBar.country = country;
  },

  setActionBarTax(state, tax) {
    state.actionBar.tax = tax;
  },

  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};
